import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Chip, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { IconPlus, IconFileDescription } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';

const STATUS_LABEL = {
    draft: { label: 'Rascunho', color: 'default' },
    sent: { label: 'Enviado', color: 'warning' },
    accepted: { label: 'Aceito', color: 'success' },
    rejected: { label: 'Rejeitado', color: 'error' },
    expired: { label: 'Expirado', color: 'default' }
};

const formatCurrencyBR = (value) => {
    const number = Number(value);
    if (Number.isNaN(number)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
};

const ViewAllSalesQuotes = () => {
    const history = useHistory();

    const [appId, setAppId] = useState(null);
    const [quotes, setQuotes] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        (async () => {
            const res = await api.get('v1/apps/default/');
            setAppId(res.data.app.id);
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        listarOrcamentos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, statusFilter]);

    const listarOrcamentos = async () => {
        const query = statusFilter ? `?status=${statusFilter}` : '';
        const res = await api.get(`v1/apps/${appId}/sales_quotes/${query}`);
        setQuotes(res.data.quotes || []);
    };

    return (
        <Box>
            <PageHeader
                icon={IconFileDescription}
                gradient="teal"
                title="Orçamentos"
                subtitle="Propostas pro cliente antes de virar pedido firme"
                actions={
                    <Stack direction="row" spacing={2}>
                        <TextField
                            select
                            size="small"
                            label="Status"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            sx={{ width: 180 }}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            <MenuItem value="draft">Rascunho</MenuItem>
                            <MenuItem value="sent">Enviado</MenuItem>
                            <MenuItem value="accepted">Aceito</MenuItem>
                            <MenuItem value="rejected">Rejeitado</MenuItem>
                            <MenuItem value="expired">Expirado</MenuItem>
                        </TextField>

                        <Button
                            variant="contained"
                            startIcon={<IconPlus size={18} />}
                            onClick={() => history.push('/dashboard/sales/quotes/new')}
                        >
                            Novo Orçamento
                        </Button>
                    </Stack>
                }
            />

            <Grid container spacing={2}>
                {quotes.map((quote) => {
                    const statusInfo = STATUS_LABEL[quote.status] || { label: quote.status, color: 'default' };
                    return (
                        <Grid item xs={12} key={quote.id}>
                            <Card sx={{ cursor: 'pointer' }} onClick={() => history.push(`/dashboard/sales/quotes/${quote.id}/`)}>
                                <CardContent>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography fontWeight={600}>{quote.organization_name}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {quote.quote_date}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Typography>{formatCurrencyBR(quote.total_amount)}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Chip label={statusInfo.label} color={statusInfo.color} size="small" />
                                        </Grid>
                                        <Grid item xs={6} sm={2}>
                                            {quote.converted && <Chip label="Convertido" size="small" variant="outlined" />}
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            {quotes.length === 0 && (
                <Box mt={10} textAlign="center" color="text.secondary">
                    <Typography variant="h6">Nenhum orçamento encontrado</Typography>
                </Box>
            )}
        </Box>
    );
};

export default ViewAllSalesQuotes;
